import { useMemo } from 'react'
import styled from 'styled-components'

import { reatomTrackedWalletTable } from '../../tables/tracked-wallet-table/atoms/reatom-tracked-wallet-table'
import { TrackedWalletTable } from '../../tables/tracked-wallet-table/ui/tracked-wallet-table'

import type { PairModel } from '@root/entities/pair'
import type { WalletAddress } from '@root/entities/wallet'

type TrackedWalletSquareTableProps = {
  pair: PairModel
  makerAddress: WalletAddress
}

export const TrackedWalletSquareTable: React.FC<
  TrackedWalletSquareTableProps
> = ({ pair, makerAddress }) => {
  const pairHoldersModelAtom = useMemo(() => {
    // eslint-disable-next-line @reatom/unit-naming-rule
    return reatomTrackedWalletTable({
      network: pair.network,
      pairAddress: pair.address,
      makerAddress,
    })
  }, [pair.address, pair.network, makerAddress])

  const context = useMemo(
    () => ({
      pairAddress: pair.address,
    }),
    [pair.address],
  )

  return <Root tableModel={pairHoldersModelAtom} context={context} />
}

const Root = styled(TrackedWalletTable)`
  height: 100%;
  --data-table-header-padding-inline: 12px;
  --data-table-row-padding-inline: 12px;

  table {
    thead > tr:first-of-type {
      background: var(--appearance-1);
      border-bottom: 1px solid var(--background-2);
    }
  }
`
